function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12 3.6c4.6 0 8.4 3.8 8.4 8.5s-3.8 8.5-8.4 8.5-8.4-3.8-8.4-8.5S7.4 3.6 12 3.6M12 0C5.4 0 0 5.4 0 12.1s5.4 12.1 12 12.1 12-5.4 12-12.1S18.6 0 12 0z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;